import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { Club } from '../../../../../../../models/club';
import { ReportActions, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../Clubs.css';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; club: Club; activeSchoolId: string | null; }

// report 013
export function ClubBookingsReportForm({ onCloseClick, onSubmit, activeSchoolId }: Props) {
  const [schoolData, setSchoolData] = React.useState<any>(null);
  React.useEffect(() => {
    fetch('/dist/images/mis/misIntegrationSchoolsList.json').then(response => response.json()).then(data => setSchoolData(data.find(item => item.schoolSITId === activeSchoolId))).catch(error => console.error('Error loading JSON:', error));
  }, [activeSchoolId]);

  const initialValues = {
    isPrintMedicalInfo: false,
    isPrintNextOfKin: false,
    isPrintPriority: true,
    isShowAccepted: true,
    isShowRejected: false,
    isShowPending: false,
    isPrintPP: false,
    isPrintSEN: false,
    isPrintFSM: false,
    isPrintEthnicity: false
  };

  return <Formik enableReinitialize initialValues={{ ...initialValues,
    isPrintPP: schoolData ? schoolData.studentsPPInfo === 1 : false,
    isPrintSEN: schoolData ? schoolData.studentsSENInfo === 1 : false,
    isPrintFSM: schoolData ? schoolData.studentsFSMInfo === 1 : false,
    isPrintEthnicity: schoolData ? schoolData.studentsEthnicityCode === 1 : false
  }} onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_BOOKINGS)}>
    {({ values, setFieldValue }) => {
      const hasBookingStatus = values.isShowAccepted || values.isShowRejected || values.isShowPending;
      return <Form className="eReportForm compactClubReportForm"><div className="eReportForm__scroll">
        <ReportDescription>One row per invitation to the selected club, showing its current booking response and, optionally, operational student information.</ReportDescription>

        <ReportSection number={1} title="Booking status" hint="Choose at least one booking status to include.">
          <ReportToggleList>
            <ReportToggle name="isShowAccepted" label="Accepted bookings" hint="Include bookings that have been accepted." value={values.isShowAccepted} onChange={value => setFieldValue('isShowAccepted', value)} />
            <ReportToggle name="isShowRejected" label="Rejected bookings" hint="Include bookings that have been rejected." value={values.isShowRejected} onChange={value => setFieldValue('isShowRejected', value)} />
            <ReportToggle name="isShowPending" label="Pending responses" hint="Include bookings that have not received a response." value={values.isShowPending} onChange={value => setFieldValue('isShowPending', value)} />
          </ReportToggleList>
        </ReportSection>

        <ReportSection number={2} title="Student characteristics" hint="Choose optional student columns to support booking review.">
          <ReportToggleList>
            <ReportToggle name="isPrintPP" label="Show PP" hint="Include pupil premium information." value={values.isPrintPP} onChange={value => setFieldValue('isPrintPP', value)} />
            <ReportToggle name="isPrintSEN" label="Show SEN" hint="Include SEN information." value={values.isPrintSEN} onChange={value => setFieldValue('isPrintSEN', value)} />
            <ReportToggle name="isPrintFSM" label="Show FSM" hint="Include free school meals information." value={values.isPrintFSM} onChange={value => setFieldValue('isPrintFSM', value)} />
            <ReportToggle name="isPrintEthnicity" label="Show ethnicity" hint="Include the ethnicity code recorded for each student." value={values.isPrintEthnicity} onChange={value => setFieldValue('isPrintEthnicity', value)} />
          </ReportToggleList>
        </ReportSection>

        <ReportSection number={3} title="Student information" hint="Choose additional information to include in the report.">
          <ReportToggleList>
            <ReportToggle name="isPrintMedicalInfo" label="Show medical information" hint="Include medical information linked to students." value={values.isPrintMedicalInfo} onChange={value => setFieldValue('isPrintMedicalInfo', value)} />
            <ReportToggle name="isPrintNextOfKin" label="Show next of kin" hint="Include next-of-kin contact details." value={values.isPrintNextOfKin} onChange={value => setFieldValue('isPrintNextOfKin', value)} />
            <ReportToggle name="isPrintPriority" label="Show booking priority" hint="Include the priority selected when the booking was made." value={values.isPrintPriority} onChange={value => setFieldValue('isPrintPriority', value)} />
          </ReportToggleList>
        </ReportSection>
      </div><ReportActions onCancel={onCloseClick} disabled={!hasBookingStatus} /></Form>;
    }}
  </Formik>;
}
